export { default as InsuranceManagementEditTemplate } from './InsuranceManagementEditTemplate';
export { default as InsuranceManagementListTemplate } from './InsuranceManagementListTemplate';
